var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJackpotStarBronzeDesktopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 186,
    viewBox: "0 0 193 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.459 13.0345L126.454 41.5158C129.751 48.226 136.135 52.879 143.524 53.9497L174.87 58.4921C189.345 60.5897 195.146 78.4498 184.648 88.6967L161.962 110.837C156.612 116.059 154.175 123.589 155.444 130.963L160.848 162.355C163.341 176.839 148.187 187.859 135.253 181.031L107.185 166.214C100.583 162.73 92.6931 162.73 86.0914 166.214L58.0233 181.031C45.0895 187.859 29.9358 176.839 32.4289 162.355L37.8323 130.963C39.1016 123.589 36.6644 116.059 31.3141 110.837L8.62895 88.6967C-1.86992 78.4499 3.93159 60.5897 18.4065 58.4921L49.7528 53.9497C57.1412 52.879 63.5255 48.226 66.8227 41.5158L80.8175 13.0345C87.2854 -0.128675 105.991 -0.128674 112.459 13.0345Z",
    fill: "url(#paint0_linear_1025_8296)",
    stroke: "url(#paint1_linear_1025_8296)",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1025_8296",
    x1: 81.2012,
    y1: 23.3341,
    x2: 144.812,
    y2: 163.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD9268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102083,
    stopColor: "#F2B694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#B67847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289583,
    stopColor: "#7C4B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471875,
    stopColor: "#EAAE8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680208,
    stopColor: "#80522E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841667,
    stopColor: "#A77B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#784625"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1025_8296",
    x1: 154.412,
    y1: 19.5929,
    x2: 76.9779,
    y2: 180.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79553F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8BCA7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackpotStarBronzeDesktopIcon);
export default __webpack_public_path__ + "static/media/jackpot_star_bronze_desktop_icon.5e9acb75521de523574d35dfaf1b13cd.svg";
export { ForwardRef as ReactComponent };